import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { BadgeColor } from '../badge/badge.component';

/**
 * Tab Panel Component
 *
 * Used as a child of app-tabs to define individual tab panels.
 */
@Component({
  selector: 'app-tab-panel',
  standalone: false,
  template: `
    <ng-template #content>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class TabPanelComponent {
  /** Unique identifier for the tab */
  @Input() id = '';

  /** Tab title displayed in the tab header */
  @Input() title = '';

  /** Optional icon name (feather icon) */
  @Input() icon = '';

  /** Whether the tab is disabled */
  @Input() disabled = false;

  /** Optional badge text to display */
  @Input() badge = '';

  /** Badge color matching Figma design system */
  @Input() badgeColor: BadgeColor = 'secondary';

  @ViewChild('content', { static: true }) contentTemplate!: TemplateRef<unknown>;
}
